import {forwardRef, useRef, useState} from 'react';
import classNames from 'classnames';
import {Tooltip as LuffyTooltip, TooltipProps as LuffyTooltipProps} from '@baidu/luffy-comp-tooltip';

import styles from './index.module.scss';

export enum TooltipTrigger {
    Click = 'click',
    Hover = 'hover',
    Focus = 'focus',
}

export interface TooltipProps extends LuffyTooltipProps {
    children?: React.ReactNode;
    trigger?: TooltipTrigger;
    innerStyle?: React.CSSProperties;
}

const Tooltip = forwardRef<LuffyTooltip, TooltipProps>((props: TooltipProps, ref) => {
    const {children, trigger, type, className, ...tooltipProps} = props;
    const tooltipTrigger = trigger;
    return (
        <LuffyTooltip
            className={classNames(styles.tooltip, className)}
            type={tooltipTrigger}
            ref={ref}
            {...tooltipProps}
        >
            {children}
        </LuffyTooltip>
    );
});

export default Tooltip;

const ellipsisStyle: React.CSSProperties = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
};

/**
 * 用于文字超长时显示省略号，并且 hover 后 tooltip 显示全部的场景
 */
export const EllipsisTooltip = (props: TooltipProps) => {
    const {children, trigger, innerStyle = {}, className, ...tooltipProps} = props;
    const tooltipTrigger = trigger;

    const ref = useRef<HTMLDivElement>(null);
    const [visible, setVisible] = useState(false);

    const handleVisibleChange = (visible: boolean) => {
        if (ref.current && ref.current.clientWidth < ref.current.scrollWidth) {
            setVisible(visible);
        }
    };

    return (
        <LuffyTooltip
            visible={visible}
            type={tooltipTrigger}
            onChange={handleVisibleChange}
            className={classNames(styles.tooltip, className)}
            {...tooltipProps}
        >
            <div
                ref={ref}
                className={styles.safariEllips}
                style={{...ellipsisStyle, ...innerStyle, cursor: visible ? 'pointer' : 'unset'}}
            >
                {children}
            </div>
        </LuffyTooltip>
    );
};
